/**
 * Shared autocomplete-card builder for /findTypes.php results.
 *
 * Both the section_form (Verkaufen/Reparatur entry-point on the home page)
 * and the global header search bar render the same card_product_search_result
 * shape when in a Verkaufen/Reparatur context. Centralizing the DOM build
 * keeps the two callers in sync.
 */

export const SEARCH_FORM_TYPE_REPAIR = 'repair';
export const SEARCH_FORM_TYPE_SELL = 'sell';

export const SEARCH_MIN_CHARS = 3;
export const SEARCH_DEBOUNCE_MS = 250;

/**
 * Build a card_product_search_result <a> element from an autocomplete row.
 *
 * @param {object} item     Row from /findTypes.php?is_ankauf=1 / ?is_repair=1
 * @param {string} formType SEARCH_FORM_TYPE_REPAIR or SEARCH_FORM_TYPE_SELL
 * @returns {HTMLAnchorElement}
 */
export function createSearchResultCard(item, formType) {
    const isRepair = formType === SEARCH_FORM_TYPE_REPAIR;
    const isRepairUnavailable = isRepair && !item.has_repair_types;

    const url = isRepair
        ? (item.repair_page_url || '#')
        : (item.buying_page_url || '#');

    const card = document.createElement('a');
    card.href = url;
    card.className = 'card_product_search_result';

    const imgWrapper = document.createElement('div');
    imgWrapper.className = 'card_product_search_result__image_wrapper';
    if (item.image_url) {
        const img = document.createElement('img');
        img.src = item.image_url;
        img.alt = item.article_type_name || '';
        img.className = 'card_product_search_result__image';
        img.loading = 'lazy';
        imgWrapper.appendChild(img);
    }

    const content = document.createElement('div');
    content.className = 'card_product_search_result__content';

    const heading = document.createElement('h3');
    heading.className = 'card_product_search_result__heading';
    heading.textContent = item.article_type_name || '';
    content.appendChild(heading);

    if (isRepairUnavailable) {
        const notice = document.createElement('span');
        notice.className = 'card_product_search_result__unavailable';
        notice.textContent = 'Reparatur z. Zt. nicht verfügbar';
        content.appendChild(notice);
    } else if (item.price) {
        const priceRow = document.createElement('div');
        priceRow.className = 'card_product_search_result__price_row';

        const price = document.createElement('span');
        price.className = 'card_product_search_result__price';
        price.textContent = item.price;
        priceRow.appendChild(price);

        if (item.uvp) {
            const uvp = document.createElement('span');
            uvp.className = 'card_product_search_result__uvp';
            uvp.textContent = 'UVP ' + item.uvp;
            priceRow.appendChild(uvp);
        }

        content.appendChild(priceRow);
    }

    card.appendChild(imgWrapper);
    card.appendChild(content);
    return card;
}
